export default class TertiaryNavigationSectionModel {
  constructor(data) {
    if (data && data.icons) {
      const { buttonsVariants, icons, iconsVariant, restrictContent } = data;
      this.buttonsVariants = buttonsVariants;
      this.iconsList = this.getIcons(icons);
      this.iconsVariant = iconsVariant;
      this.identifier =
        data.identifier.toLowerCase() === 'tertiarynavigationsectionv2'
          ? 'secondary'
          : 'primary';
      this.restrictContent = restrictContent;
    }
  }

  getIcons(icons) {
    if (!icons.length) return [];
    const getIconsList = icons.map(icon => {
      const {
        fields: {
          entryTitle,
          url,
          buttonImage: {
            fields: {
              file: { url: imageUrl },
            },
          },
        },
      } = icon;
      return { title: entryTitle, url, imageUrl };
    });
    return getIconsList;
  }
}
